// 默认肇庆产业分类
let industryList = [
  { label: '汽车及汽车零部件', value: '1' },
  { label: '电子信息', value: '2' },
  { label: '生物医药', value: '3' },
  { label: '现代农业与食品', value: '4' }
]

let industryLists = [
  { name: '汽车及汽车零部件', value: '1', key: '1' },
  { name: '电子信息', value: '2', key: '2' },
  { name: '生物医药', value: '3', key: '3' },
  { name: '现代农业与食品', value: '4', key: '4' }
]
let key = process.env.VUE_APP_KEY
console.log(key)
switch (key) {
  case 'Hy': // 河源
    industryList = [
      { label: '新一代电子信息', value: '1' },
      { label: '先进材料', value: '2' },
      { label: '精密仪器', value: '3' }
    ]
    industryLists = [
      { name: '新一代电子信息', value: '1', key: '1' },
      { name: '先进材料', value: '2', key: '2' },
      { name: '精密仪器', value: '3', key: '3' }
    ]
    break
  case 'Yj': // 阳江
    industryList = [
      { label: '新能源产业', value: '1' },
      { label: '高端装备制造产业', value: '2' },
      { label: '前沿新材料产业', value: '3' },
      { label: '五金刀剪产业', value: '4' }
    ]
    industryLists = [
      { name: '新能源产业', value: '1', key: '1' },
      { name: '高端装备制造产业', value: '2', key: '2' },
      { name: '前沿新材料产业', value: '3', key: '3' },
      { name: '五金刀剪产业', value: '4', key: '4' }
    ]
    break
  case 'Mm': // 茂名
    industryList = [{ label: '绿色石化', value: '1' }]
    industryLists = [{ name: '绿色石化', value: '1', key: '1' }]
    break
  case 'Mz': // 梅州
    industryList = [{ label: '南药产业', value: '1' }]
    industryLists = [{ name: '南药产业', value: '1', key: '1' }]
    break
  case 'SzTech': // 深圳市新材料产业知识产权运营公共服务平台
    industryList = []
    industryLists = []
    break
}

module.exports = {
  industryList,
  industryLists
}
